import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'or-view-toggle',
    templateUrl: './view-toggle.component.html',
    styleUrls: ['./view-toggle.component.scss'],
    standalone: false
})
export class ViewToggleComponent implements OnInit {
  @Input() showList = false;
  @Input() showCardGroup = false;
  @Input() showCard = false;
  @Input() showGantt = false;
  @Input() showCalendar = false;
  @Input() showPercent = false;
  @Input() showNumber = false;
  @Input() class = '';
  @Input() active = '';
  // Tooltips for the two card modes, for pages where they mean something other than plain cards.
  @Input() cardTooltip = 'Cards';
  @Input() cardGroupTooltip = 'Stacked Cards';

  quotas = null;

  @Output() valueChange = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (this.showNumber && this.showPercent) {
      this.quotas = 'quotas';
    }
  }

  switchMode(mode) {
    this.active = mode;
    this.valueChange.emit(mode);
  }

}
